import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFlatNodeInstance, type FlatNodeInstanceResponse } from 'api/node_instances/endpoints/getFlatNodeInstance';

interface FlatNodeInstancesState {
  instance: FlatNodeInstanceResponse;
  error: string | null;
  status: string | null;
}

const initialState: FlatNodeInstancesState = {
  instance: {
    node_instance: null,
    child_nodes: [],
    child_edges: [],
  },
  error: null,
  status: null,
};

export const fetchFlatNodeInstance = createAsyncThunk<FlatNodeInstanceResponse, number>('nodeInstances/fetchFlatNodeInstance', async (instance_id) => {
  const data = await getFlatNodeInstance(instance_id);
  return {
    ...data,
    // The viewer expects lowercased child statuses (a display concern, kept
    // here rather than in the boundary loader).
    child_nodes: data.child_nodes.map((node) => ({
      ...node,
      status: node.status?.toLowerCase() ?? node.status,
    })),
  };
});

const flatNodeInstances = createSlice({
  name: 'flatNodeInstances',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchWorkers
      .addCase(fetchFlatNodeInstance.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFlatNodeInstance.fulfilled, (state, action) => {
        state.instance = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchFlatNodeInstance.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch instances';
      });
  },
});

export default flatNodeInstances.reducer;
